// @generated from CLDR locale data (@formatjs/intl-displaynames), then filtered to the tags
// accepted by the IsLocaleTag validator on the API side. Every tag is exactly five characters,
// as uiRegionalFormat is varchar(5) in the API.

export const REGIONAL_FORMAT_TAGS: readonly string[] = [
  'af-NA',
  'af-ZA',
  'ak-GH',
  'am-ET',
  'ar-AE',
  'ar-BH',
  'ar-DJ',
  'ar-DZ',
  'ar-EG',
  'ar-ER',
  'ar-IL',
  'ar-IQ',
  'ar-JO',
  'ar-KM',
  'ar-KW',
  'ar-LB',
  'ar-LY',
  'ar-MA',
  'ar-MR',
  'ar-OM',
  'ar-PS',
  'ar-QA',
  'ar-SA',
  'ar-SD',
  'ar-SO',
  'ar-SS',
  'ar-SY',
  'ar-TD',
  'ar-TN',
  'ar-YE',
  'as-IN',
  'be-BY',
  'bg-BG',
  'bn-BD',
  'bn-IN',
  'bo-CN',
  'bo-IN',
  'br-FR',
  'ca-AD',
  'ca-ES',
  'ca-FR',
  'ca-IT',
  'cs-CZ',
  'cy-GB',
  'da-DK',
  'da-GL',
  'de-AT',
  'de-BE',
  'de-CH',
  'de-DE',
  'de-IT',
  'de-LI',
  'de-LU',
  'dz-BT',
  'ee-GH',
  'ee-TG',
  'el-CY',
  'el-GR',
  'en-AE',
  'en-AG',
  'en-AI',
  'en-AS',
  'en-AT',
  'en-AU',
  'en-BB',
  'en-BE',
  'en-BI',
  'en-BM',
  'en-BS',
  'en-BW',
  'en-BZ',
  'en-CA',
  'en-CC',
  'en-CH',
  'en-CK',
  'en-CM',
  'en-CX',
  'en-CY',
  'en-DE',
  'en-DK',
  'en-DM',
  'en-ER',
  'en-FI',
  'en-FJ',
  'en-FK',
  'en-FM',
  'en-GB',
  'en-GD',
  'en-GG',
  'en-GH',
  'en-GI',
  'en-GM',
  'en-GU',
  'en-GY',
  'en-HK',
  'en-IE',
  'en-IL',
  'en-IM',
  'en-IN',
  'en-IO',
  'en-JE',
  'en-JM',
  'en-KE',
  'en-KI',
  'en-KN',
  'en-KY',
  'en-LC',
  'en-LR',
  'en-LS',
  'en-MG',
  'en-MH',
  'en-MO',
  'en-MP',
  'en-MS',
  'en-MT',
  'en-MU',
  'en-MW',
  'en-MY',
  'en-NA',
  'en-NF',
  'en-NG',
  'en-NL',
  'en-NR',
  'en-NU',
  'en-NZ',
  'en-PG',
  'en-PH',
  'en-PK',
  'en-PN',
  'en-PR',
  'en-PW',
  'en-RW',
  'en-SB',
  'en-SC',
  'en-SD',
  'en-SE',
  'en-SG',
  'en-SH',
  'en-SI',
  'en-SL',
  'en-SS',
  'en-SX',
  'en-SZ',
  'en-TC',
  'en-TK',
  'en-TO',
  'en-TT',
  'en-TV',
  'en-TZ',
  'en-UG',
  'en-UM',
  'en-US',
  'en-VC',
  'en-VG',
  'en-VI',
  'en-VU',
  'en-WS',
  'en-ZA',
  'en-ZM',
  'en-ZW',
  'es-AR',
  'es-BO',
  'es-BR',
  'es-BZ',
  'es-CL',
  'es-CO',
  'es-CR',
  'es-CU',
  'es-DO',
  'es-EC',
  'es-ES',
  'es-GQ',
  'es-GT',
  'es-HN',
  'es-MX',
  'es-NI',
  'es-PA',
  'es-PE',
  'es-PH',
  'es-PR',
  'es-PY',
  'es-SV',
  'es-US',
  'es-UY',
  'es-VE',
  'et-EE',
  'eu-ES',
  'fa-AF',
  'fa-IR',
  'ff-CM',
  'ff-GN',
  'ff-MR',
  'ff-NG',
  'fi-FI',
  'fo-DK',
  'fo-FO',
  'fr-BE',
  'fr-BF',
  'fr-BI',
  'fr-BJ',
  'fr-BL',
  'fr-CA',
  'fr-CD',
  'fr-CF',
  'fr-CG',
  'fr-CH',
  'fr-CI',
  'fr-CM',
  'fr-DJ',
  'fr-DZ',
  'fr-FR',
  'fr-GA',
  'fr-GF',
  'fr-GN',
  'fr-GP',
  'fr-GQ',
  'fr-HT',
  'fr-KM',
  'fr-LU',
  'fr-MA',
  'fr-MC',
  'fr-MF',
  'fr-MG',
  'fr-ML',
  'fr-MQ',
  'fr-MR',
  'fr-MU',
  'fr-NC',
  'fr-NE',
  'fr-PF',
  'fr-PM',
  'fr-RE',
  'fr-RW',
  'fr-SC',
  'fr-SN',
  'fr-SY',
  'fr-TD',
  'fr-TG',
  'fr-TN',
  'fr-VU',
  'fr-WF',
  'fr-YT',
  'fy-NL',
  'ga-IE',
  'gd-GB',
  'gl-ES',
  'gu-IN',
  'gv-IM',
  'he-IL',
  'hi-IN',
  'hr-BA',
  'hr-HR',
  'hu-HU',
  'hy-AM',
  'id-ID',
  'ig-NG',
  'ii-CN',
  'is-IS',
  'it-CH',
  'it-IT',
  'it-SM',
  'it-VA',
  'ja-JP',
  'ka-GE',
  'ki-KE',
  'kk-KZ',
  'kl-GL',
  'km-KH',
  'kn-IN',
  'ko-KP',
  'ko-KR',
  'kw-GB',
  'ky-KG',
  'lb-LU',
  'lg-UG',
  'ln-AO',
  'ln-CD',
  'ln-CF',
  'ln-CG',
  'lo-LA',
  'lt-LT',
  'lu-CD',
  'lv-LV',
  'mg-MG',
  'mi-NZ',
  'mk-MK',
  'ml-IN',
  'mn-MN',
  'mr-IN',
  'ms-BN',
  'ms-MY',
  'mt-MT',
  'my-MM',
  'nd-ZW',
  'ne-IN',
  'ne-NP',
  'nl-AW',
  'nl-BE',
  'nl-BQ',
  'nl-CW',
  'nl-NL',
  'nl-SR',
  'nl-SX',
  'nn-NO',
  'om-ET',
  'om-KE',
  'or-IN',
  'os-GE',
  'os-RU',
  'pa-IN',
  'pl-PL',
  'ps-AF',
  'ps-PK',
  'pt-AO',
  'pt-BR',
  'pt-CH',
  'pt-CV',
  'pt-GQ',
  'pt-GW',
  'pt-LU',
  'pt-MO',
  'pt-MZ',
  'pt-PT',
  'pt-ST',
  'pt-TL',
  'rm-CH',
  'rn-BI',
  'ro-MD',
  'ro-RO',
  'ru-BY',
  'ru-KG',
  'ru-KZ',
  'ru-MD',
  'ru-RU',
  'ru-UA',
  'rw-RW',
  'sa-IN',
  'se-FI',
  'se-NO',
  'se-SE',
  'sg-CF',
  'si-LK',
  'sk-SK',
  'sl-SI',
  'so-DJ',
  'so-ET',
  'so-KE',
  'so-SO',
  'sq-AL',
  'sq-MK',
  'sv-AX',
  'sv-FI',
  'sv-SE',
  'sw-KE',
  'sw-TZ',
  'sw-UG',
  'ta-IN',
  'ta-LK',
  'ta-MY',
  'ta-SG',
  'te-IN',
  'th-TH',
  'ti-ER',
  'ti-ET',
  'tk-TM',
  'to-TO',
  'tr-CY',
  'tr-TR',
  'tt-RU',
  'ug-CN',
  'uk-UA',
  'ur-IN',
  'ur-PK',
  'vi-VN',
  'wo-SN',
  'xh-ZA',
  'yo-BJ',
  'yo-NG',
  'zh-CN',
  'zh-HK',
  'zh-MO',
  'zh-SG',
  'zh-TW',
  'zu-ZA',
];

// Curated for this org's primary markets — shown above the full list before the user searches.
export const SUGGESTED_REGIONAL_FORMAT_TAGS: readonly string[] = [
  'fi-FI',
  'sv-SE',
  'et-EE',
  'lt-LT',
  'lv-LV',
];
